import React, { Component } from "react";
import { userListByGroupRequest, userListRequest } from "../../../reduxRelated/actions/userActions";
import { languageService } from "../../../Language/language.service";
import { CRUDFunction } from "../../../reduxCURD/container";
import { updateShortSchema } from "../../../libraries/form/schemaInterpreter";
import _ from "lodash";
import { deleteHosRecordsSchema } from "./Schemas/schema";
import CustomForm from "../../../libraries/form";
import { toast } from "react-toastify";
import moment from "moment";
class RemoveHosRecords extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchFilters: { employeeEmail: "" },
      selectedUser: null,
      users: [],
      searchFiltersFormSchema: _.cloneDeep(deleteHosRecordsSchema),
    };
    this.compileSearchHosRecordsFormSchema = this.compileSearchHosRecordsFormSchema.bind(this);
    this.removeRecords = this.removeRecords.bind(this);
  }
  componentDidMount() {
    // Fetch All Users
    this.props.userListRequest();
  }
  componentDidUpdate(prevProps) {
    const { userActionType, userList, actionType } = this.props;
    if (userActionType !== prevProps.userActionType) {
      if (userActionType === "USER_LIST_REQUEST") {
      } else if (userActionType === "USER_LIST_SUCCESS") {
        if (Array.isArray(userList)) {
          const userSelectOptions = [
            { val: "", text: languageService("Select") },
            ...userList
              .filter((user) => user.HosInfo && user.HosInfo.startDate && user.HosInfo.timezone)
              .map((user) => ({ val: user.email, text: `${user.name} (${user.email})` })),
          ];
          this.setState({
            users: [...userList],
            searchFiltersFormSchema: this.compileSearchHosRecordsFormSchema(userSelectOptions),
          });
        }
      } else if (userActionType === "USER_LIST_FAILURE") {
      }
    }
    if (prevProps.actionType !== actionType && actionType === "REMOVEHOSRECORDS_READ_SUCCESS") {
      toast.success("Removed HOS records successfully!", { position: toast.POSITION.TOP_RIGHT });
    }
    if (prevProps.actionType !== actionType && actionType === "REMOVEHOSRECORDS_READ_FAILURE") {
      toast.error("Error Occurred!", { position: toast.POSITION.TOP_RIGHT });
    }
  }
  compileSearchHosRecordsFormSchema(userSelectOptions) {
    let formSchema = updateShortSchema(_.cloneDeep(deleteHosRecordsSchema), {
      employeeEmail: {
        selectOptions: userSelectOptions,
      },
    });
    return formSchema;
  }
  removeRecords(submission) {
    this.setState({ searchFilters: _.cloneDeep(submission.fields) });
    const { getRemoveHosRecords } = this.props;
    const { employeeEmail, startDate } = submission.fields;
    console.log(startDate, typeof startDate, startDate.toISOString());
    getRemoveHosRecords &&
      getRemoveHosRecords(`diagnostics/markMistake/?employeeEmail=${employeeEmail}&date=${moment(startDate).format("YYYY-MM-DD")}`);
  }
  render() {
    const { searchFiltersFormSchema, searchFilters } = this.state;
    return (
      <div style={{ width: "100%", padding: "20px" }}>
        {searchFiltersFormSchema && searchFilters && (
          <CustomForm
            hideFormTitle={true}
            mode="inline"
            fieldsData={searchFilters}
            formSchema={searchFiltersFormSchema}
            parentRef={{
              removeRecords: this.removeRecords,
            }}
          />
        )}
      </div>
    );
  }
}

let variableList = {
  userReducer: {
    userList: [],
    userListByGroup: [],
  },
};
let reducers = ["userReducer"];

let actionOptions = {
  read: true,
  delete: true,
  others: { userListRequest, userListByGroupRequest },
};

const RemoveHosRecordsContainer = CRUDFunction(
  RemoveHosRecords,
  "RemoveHosRecords",
  actionOptions,
  variableList,
  reducers,
  "applicationlookups",
);

export default RemoveHosRecordsContainer;



// WEBPACK FOOTER //
// ./src/components/diagnostics/RemoveHosRecords/index.jsx